module.exports = __webpack_public_path__ + "img/1557614056822611971.5fb516eb.png";